// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__FciFh","loading-spinner":"Spinner_loading-spinner__rzyv-","spin":"Spinner_spin__fs87b"};